import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=5c6fd6f3&"
import script from "./baseinfo.vue?vue&type=script&lang=js&"
export * from "./baseinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports